(() => {
  function start() {
    const badges = [...document.querySelectorAll('.header .cartnum')];
    if (!badges.length || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    let request;
    const render = count => badges.forEach(badge => {
      badge.textContent = String(count);
      badge.dataset.count = String(count);
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const count = event.cartData?.item_count;
      if (Number.isInteger(count)) {
        render(count);
        return;
      }
      if (!request) {
        const root = window.Shopify?.routes?.root || '/';
        request = fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})
          .then(response => response.ok ? response.json() : null)
          .then(cart => { if (Number.isInteger(cart?.item_count)) render(cart.item_count); })
          .catch(() => {})
          .finally(() => { request = null; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
